<template>
  <aw-tab-version2 tab-type="page" :header-items="tabHeaders">
    <template #content>
      <div :class="$style.tabContentWrapper">
        <aw-tab-content-version2
          :tab-index="0"
        >
          <aw-aggregated-pages-cards
            :params="params"
            :page-type="pageType"
          />
        </aw-tab-content-version2>
        <aw-tab-content-version2
          v-for="(menu, i) in tabOptions"
          :key="menu.id"
          :tab-index="i+1"
        >
          <aw-aggregated-pages-cards
            :params="{
              tag: menu.id,
              ...params
            }"
            :page-type="pageType"
          />
        </aw-tab-content-version2>
      </div>
    </template>
  </aw-tab-version2>
</template>

<script setup>
  import { defineAsyncComponent } from 'vue';
  import { useNuxtApp, useAsyncData } from 'nuxt/app';
  import { setErrorNotification } from '~~/common/utils/helper';
  import AwTabContentVersion2 from '~~/common/components/Common/AwTabContentVersion2';
  import AwAggregatedPagesCards from './AwAggregatedPageCards';

  const AwTabVersion2 = defineAsyncComponent(() => import('~~/common/components/Common/AwTabVersion2'));

  const props = defineProps({
    pageType: {
      type: String,
      required: true,
    },
    params: {
      type: Object,
      required: true,
    },
  });

  const nuxtApp = useNuxtApp();
  const {
    $api,
    $awt,
    $logger,
  } = nuxtApp;
  const dataKey = computed(() => `/cms/tags/${props.pageType}`);
  const { data: tabOptions } = await useAsyncData(
    dataKey.value,
    async () => {
      return await fetchTabs();
    },
    {
      default: () => [],
    },
  );

  const tabHeaders = computed(() => {
    return [
      {
        label: $awt('aw.pages.aggregated_common.tabs.all'),
        tabItemId: 0,
      },
      ...((Array.isArray(tabOptions.value) ? tabOptions.value : [])
        .map((menu, index) => ({
          label: menu.name,
          tabItemId: index + 1,
        }))
      ),
    ];
  });

  async function fetchTabs () {
    try {
      const result = await $api.$get(dataKey.value);
      if (Array.isArray(result)) {
        return result;
      } else {
        throw new TypeError(`Bad response from /cms/tags/${props.pageType} API. Expected an array, got ${typeof result}.`);
      }
    } catch (error) {
      $logger.error(error);
      setErrorNotification({
        nuxtApp,
        error,
      });
      return [];
    }
  }
</script>

<style module lang="scss" rel="stylesheet/scss">
.tabContentWrapper {
  padding-top: 20px;
  @include tablet(min) {
    padding-top: 40px;
  }
}
</style>
